import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { totalPrice } from "../../utils";
import "./style.scss";
import axios from "axios";
import { ShimmerButton, ShimmerCategoryList, ShimmerCircularImage, ShimmerTitle } from "react-shimmer-effects";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
const excludeKeys = ["addresid"]; // Add the keys you don't want to display here
const SuccessOrder = ({ carts, token, ...props }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    if (seconds === 0) {
      HandelRedirect();
      return;
    }
    const timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
    return () => clearTimeout(timer);
  }, [seconds]);
  // console.log({ data });
  const [orderId, setOrderId] = useState("");
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const orderId = params.get("orderId");
    setOrderId(orderId);
    console.log({ params, orderId });
  }, []);

  const getUserCartData = async () => {
    setLoading(true);
    if (error) setError(false);
    await axios
      .get("https://api.paymentservice.me/v1/auth/getOrderDetails", {
        params: { orderid: orderId },
      })
      .then((res) => {
        console.log(res);
        setData(res?.data);
        setLoading(false);
        setTimeout(() => {
          window.location.href = res?.data?.success_url;
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        setError(true);
      });
  };

  useEffect(() => {
    if (orderId !== "") {
      getUserCartData();
    }
  }, [orderId]);

  const HandelRedirect = () => {
    if (data?.success_url) {
      // const domain = new URL(data?.success_url).hostname.replace(/^www\./, "");
      window.location.href = data?.success_url;
    } else {
      toast.error("Something went wrong!");
    }
  };

  const styles = {
    paragraph: {
      fontSize: "14px",
      color: "#555",
      marginBottom: "1.5rem",
      marginTop: "1rem",
    },
    timer: {
      color: "red",
      fontWeight: "bold",
    },
    button: {
      backgroundColor: "#007bff",
      color: "#fff",
      border: "none",
      padding: "12px 24px",
      fontSize: "16px",
      borderRadius: "6px",
      cursor: "pointer",
      transition: "background-color 0.3s ease",
    },
  };
  return (
    <section className="cart-recived-section separator-padding">
      <div className="container">
        {loading ? (
          <div className="row">
            <div className="order-box">
              <div className="row p-10 mt-20">
                <div className="col-2 col-xl-2">
                  <ShimmerCircularImage size={100} />
                </div>
                <div className="col-8 col-xl-8">
                  <ShimmerTitle className="mb-0" line={3} variant={"secondary"} />
                </div>
                <div className="col-2 col-xl-2">
                  <ShimmerButton size="md" />
                </div>
              </div>
              <ShimmerCategoryList items={4} categoryStyle="STYLE_SIX" />
            </div>
          </div>
        ) : !loading && error && isEmpty(data) ? (
          <div className="row">
            <div className="order-box flex items-center justify-center">
              <h1>
                Oops!
                <p>Could'nt load the data</p>
              </h1>
              <img
                src={
                  "https://cdn3d.iconscout.com/3d/premium/thumb/failed-3d-icon-download-in-png-blend-fbx-gltf-file-formats--document-folder-chat-pack-communication-icons-9316807.png?f=webp"
                }
                alt={"error-image"}
              />
            </div>
          </div>
        ) : (
          <>
            {" "}
            {data?.result === "success" ? (
              <div className="main-div-home-page-pappa">
                <div className="main-div-home-page-success">
                  <div>
                    <div className="gift-card">
                      <img src="./voucher.png" alt="voucher " />
                      <p>{data?.name}</p>
                    </div>
                  </div>

                  <div className="min-h-screen bg-gray-950 px-4 py-12 mt-2">
                    <div className=" bg-gray-900 text-white rounded-2xl shadow-2xl p-8 sm:p-10 ">
                      <div className="flex items-center gap-2 ">
                        <div style={{ fontSize: "35px" }}>🎉</div>

                        <h2 style={{ color: "#56b548", fontWeight: "bolder" }}>Payment Successful</h2>
                      </div>

                      <p style={{ fontSize: "18px" }} className=" text-base sm:text-lg  leading-relaxed mb-6 mt-4">
                        Your transaction is complete. The voucher amount has been credited to your account.
                      </p>

                      <div className="mt-8">
                        <button
                          onClick={() => HandelRedirect()}
                          className="w-full sm:w-auto border border-gray-700 text-gray-300 hover:text-white hover:border-white px-6 py-2 rounded-lg transition-all mt-5"
                        >
                          Go Back to Home
                        </button>
                      </div>
                      <p style={styles.paragraph}>
                        If you are not automatically redirected within <span style={styles.timer}>{seconds} seconds</span>, please click the above below.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="main-div-home-page-pappa">
                <div className="main-div-home-page">
                  <div>
                    <div className="gift-card">
                      <img src="./voucher.png" alt="voucher " width="300px" height={"90%"} />
                      <p>{data?.name}</p>
                    </div>
                  </div>

                  <div className="min-h-screen bg-gray-950 px-4 py-12 mt-2">
                    <div className="max-w-2xl w-full bg-gray-900 text-white rounded-2xl shadow-2xl p-8 sm:p-10">
                      <div className="flex items-center gap-4 mb-6">
                        <div style={{ fontSize: "35px" }}>❌</div>

                        <h2 style={{ color: "#f92d66", fontWeight: "bolder" }}>Payment Failed</h2>
                      </div>

                      <p style={{ fontSize: "18px" }} className=" text-base sm:text-lg  leading-relaxed mb-6 mt-4">
                        Unfortunately, your payment didn’t go through. No charges were made. Please try again or use a different payment method.
                      </p>

                      <div className="mt-8">
                        <button
                          onClick={() => HandelRedirect()}
                          className="w-full sm:w-auto border border-gray-700 text-gray-300 hover:text-white hover:border-white px-6 py-2 rounded-lg transition-all mt-5"
                        >
                          Go Back to Home
                        </button>
                      </div>
                      <p style={styles.paragraph}>
                        If you are not automatically redirected within <span style={styles.timer}>{seconds} seconds</span>, please click the above below.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
          // <div id="order-success-page">

          //   <h1 className="text-4xl font-bold mb-2">🎉 Payment Successful</h1>
          //   <h4 className="text-3xl font-bold mb-4 animate-pulse">Your transaction is complete. The voucher amount has been credited to your account.</h4>

          //   <p className="mt-6 text-sm text-white text-opacity-70">Redirecting to your voucher page...</p>
          // </div>
        )}
      </div>
    </section>
  );
};

export default SuccessOrder;
